// @flow
export const SET_NID_STRING = 'nid/SET_NID_STRING';
export const CLEAR_NID_STRING = 'nid/CLEAR_NID_STRING';

export function setNidString( nidString ) {
    return {
        type: SET_NID_STRING,
        nidString
    };
}

export function clearNidString() {
    return {
        type: CLEAR_NID_STRING
    };
}